import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getUnitType(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createUnitType(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/unit-type" + pathname, body);
}

export async function updateUnitType(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/unit-type" + pathname + queryParams, body);
}

export async function deleteUnitType(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/unit-type" + pathname + queryParams);
}
